import React from 'react';
import { InvestorAccountCreate } from '@components-member/TradingAccounts/AccountCreate/components/Forms/Investor';
import { MasterAccountCreate } from '@components-member/TradingAccounts/AccountCreate/components/Forms/Master';
import { TradingAccountCreate } from '@components-member/TradingAccounts/AccountCreate/components/Forms/Trading';
import {
  DEMO_ACCOUNT_FIELDS,
  SELF_ACCOUNT_FIELDS,
} from '@components-member/TradingAccounts/AccountCreate/components/Forms/Trading/constants';
import { IBaseAccountCreateProps } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import { TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';
import { observer } from 'mobx-react';

const { DEMO, MASTER, INVESTOR, SELF } = TRADING_ACCOUNT_FORM_TYPE;

export const AccountCreateForm = observer((props: IBaseAccountCreateProps) => {
  const getForm = () => {
    switch (props.accountType) {
      case SELF:
        return <TradingAccountCreate formFields={SELF_ACCOUNT_FIELDS} {...props} />;
      case DEMO:
        return <TradingAccountCreate formFields={DEMO_ACCOUNT_FIELDS} {...props} />;
      case MASTER:
        return <MasterAccountCreate {...props} />;
      case INVESTOR:
        return <InvestorAccountCreate {...props} />;
      default:
        return <></>;
    }
  };

  return getForm();
});
